React = require 'react'
Label = require 'models/label'
{ MicroCanonicalCard } = require 'views/canonical-card/canonical-card-components'
t = require 'recup'

module.exports = class CalendarCardEvent extends React.Component
  displayName: 'Calendar Card Event'

  render: t.renderable ->
    card = @props.event.card
    badge = @props.event.badge
    t.tag MicroCanonicalCard,
      badge: badge
      card: card
      labels: card.getLabels().sort(Label.compare)



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-card-event.coffee